export const PRODUCTS_A = {
  'business-loans': {
    name: 'Business Loan',
    heroTitle: 'Business Loans Built Around Your Growth Plans',
    heroSub: 'Collateral-free and secured business loans from ₹10 Lakh to ₹50 Crore, structured by corporate finance specialists and placed with the right lender from our network of leading financial institutions.',
    amount: '₹10 Lakh – ₹50 Cr',
    timeline: '7–15 days',
    rate: '14% p.a. onwards',
    metaTitle: 'Business Loan in India | LOANYARD CAPITAL',
    metaDescription: 'Business loans from ₹10 Lakh to ₹50 Cr for MSMEs and corporates. comprehensive lender network, expert structuring, fast approvals. Get a free consultation.',
    focusKeyword: 'business loan India',
    intro: [
      'A business loan remains the most direct instrument for financing expansion, bridging cash-flow gaps and seizing time-sensitive opportunities. Yet most Indian businesses approach only one or two banks and accept whatever terms are offered. The result is predictable: higher pricing, inadequate limits and covenants that constrain growth.',
      'LOANYARD CAPITAL approaches business lending as an advisory mandate, not a transaction. We begin with your financial statements, banking conduct and growth plan, then prepare a lender-grade proposal and place it competitively across our comprehensive network of financial institutions. Because lenders view each application through their own credit policies, competitive placement routinely improves both the sanctioned amount and the interest rate.',
      'Whether you are an MSME seeking your first institutional facility or a mid-market company consolidating multiple high-cost loans, our team structures the debt around your cash flows — term loans, working capital, overdrafts or a blended facility — and manages the process end to end, from documentation to disbursement.'
    ],
    benefits: [
      'Loan amounts from ₹10 Lakh to ₹50 Crore, secured or unsecured',
      'Competitive placement across leading financial institutions',
      'Pricing from 14% p.a. onwards — subject to borrower profile, lender assessment, financials, credit profile and applicable terms',
      'Minimal-collateral structures for established businesses',
      'Doorstep documentation and a dedicated relationship manager',
      'Sanction typically within 7–15 working days'
    ],
    whoShouldApply: [
      'MSMEs and proprietorships with 2+ years of operations',
      'Private limited companies planning capacity expansion',
      'Businesses consolidating multiple high-cost debts',
      'Traders and distributors needing higher working limits',
      'Professionals and partnerships scaling operations'
    ],
    eligibility: [
      'Business vintage of 2 years or more',
      'Minimum annual turnover of ₹40 Lakh (varies by lender)',
      'Satisfactory banking conduct over the last 12 months',
      'CIBIL / credit bureau score of 685+ preferred',
      'Profitable operations in at least one of the last two years'
    ],
    documents: [
      'KYC of promoters and business entity',
      'Last 2–3 years audited financial statements',
      'Last 12 months bank statements (all operating accounts)',
      'GST returns for the last 12 months',
      'Existing loan sanction letters and repayment track',
      'Business profile and end-use note'
    ],
    industries: ['Manufacturing', 'Trading & Distribution', 'Healthcare', 'Logistics', 'Retail', 'IT & Services', 'Food Processing', 'Textiles'],
    process: [
      ['Consultation', 'We understand your requirement, financials and timelines.'],
      ['Structuring', 'Our analysts prepare a lender-grade proposal and select target lenders.'],
      ['Placement', 'The proposal is placed with multiple lenders to create competition.'],
      ['Negotiation', 'We negotiate amount, rate, tenure and covenants on your behalf.'],
      ['Disbursement', 'Documentation, sanction and disbursal are managed end to end.']
    ],
    faqs: [
      ['What is the maximum business loan amount I can get?', 'Depending on your financials and security offered, facilities range from ₹10 Lakh unsecured to ₹50 Crore+ for secured structured debt.'],
      ['Can I get a business loan without collateral?', 'Yes. Unsecured business loans up to ₹5 Crore are available for businesses with strong financials, and CGTMSE-backed loans offer collateral-free funding up to ₹5 Crore for eligible MSMEs.'],
      ['What interest rate should I expect?', 'Business loan pricing starts from 14% p.a. onwards. Actual pricing is subject to borrower profile, lender assessment, financials, credit profile and applicable terms. Competitive placement across lenders usually improves pricing.'],
      ['How long does approval take?', 'Unsecured loans can be sanctioned in 5–10 days. Secured and structured facilities typically take 2–4 weeks including valuation and legal checks.'],
      ['Does applying through LOANYARD CAPITAL cost more?', 'No. Our advisory ensures you approach the right lenders once, with a complete file — avoiding multiple bureau hits and rejections that damage your credit profile.'],
      ['My CIBIL score is below 685. Can I still get funded?', 'Often yes — through secured products, co-applicant structures or NBFC programmes. We assess your profile and recommend the most viable route.'],
      ['Can I consolidate existing loans into one facility?', 'Yes. Debt consolidation through a single lower-cost facility is one of our most common mandates and can significantly reduce monthly outflow.'],
      ['Is a new business eligible?', 'Most lenders require 2 years of vintage, but project finance, CGTMSE and promoter-backed structures can fund earlier-stage businesses.'],
      ['What is the typical tenure?', 'Unsecured loans run 1–5 years; secured term loans extend up to 15 years depending on collateral and cash flows.'],
      ['Which cities do you serve?', 'We operate pan-India with presence across Mumbai, Delhi, Bengaluru, Chennai, Hyderabad, Kolkata, Ahmedabad and other major centres.']
    ],
    related: ['msme-business-funding', 'working-capital-finance', 'cgtmse-loan', 'loan-against-property']
  },

  'msme-business-funding': {
    name: 'MSME Business Funding',
    heroTitle: 'Institutional Funding for India\'s MSMEs',
    heroSub: 'From CGTMSE-backed collateral-free loans to structured working capital, we help micro, small and medium enterprises access bank-grade funding on terms usually reserved for large corporates.',
    amount: '₹10 Lakh – ₹25 Cr',
    timeline: '7–21 days',
    rate: '9.5% p.a. onwards',
    metaTitle: 'MSME Business Funding & Loans | LOANYARD CAPITAL',
    metaDescription: 'MSME funding from ₹10 Lakh to ₹25 Cr — CGTMSE loans, working capital, machinery finance. multiple financing partners, expert advisory, pan-India. Free eligibility check.',
    focusKeyword: 'MSME loan India',
    intro: [
      'MSMEs contribute nearly 30% of India\'s GDP, yet the credit gap for the sector is estimated at over ₹25 lakh crore. The problem is rarely creditworthiness — it is presentation, lender selection and structuring. Banks decline good businesses every day because the proposal did not speak the lender\'s language.',
      'LOANYARD CAPITAL bridges this gap. Our team converts your business reality — GST data, banking conduct, order book and receivables — into a bankable proposal, then places it with lenders whose credit policy actually fits your profile. For eligible enterprises, we structure CGTMSE-guaranteed loans that require no collateral at all.',
      'Beyond a single loan, we design a complete funding stack for growing MSMEs: cash credit for daily operations, term debt for capacity, machinery finance for equipment and bill discounting for receivables — sequenced so each facility strengthens eligibility for the next.'
    ],
    benefits: [
      'Collateral-free funding up to ₹5 Cr under CGTMSE',
      'Blended facilities: term loan + working capital + equipment finance',
      'Interest rates from 9.5% p.a. with PSU and private banks',
      'Udyam-registered enterprises get priority-sector advantages',
      'Proposal preparation that meets bank credit standards',
      'Dedicated MSME desk with pan-India lender relationships'
    ],
    whoShouldApply: [
      'Udyam-registered micro, small and medium enterprises',
      'Manufacturers adding capacity or modernising equipment',
      'Suppliers to corporates and PSUs with growing order books',
      'Exporters and importers needing trade limits',
      'Service businesses scaling teams and infrastructure'
    ],
    eligibility: [
      'Udyam registration (we assist if not yet registered)',
      'Business vintage of 2+ years (relaxed for CGTMSE in some cases)',
      'GST-compliant turnover records',
      'No current NPA or major bounced-cheque history',
      'Promoter credit score of 650+ preferred'
    ],
    documents: [
      'Udyam certificate and business KYC',
      'Last 2 years financials and provisional statements',
      '12-month bank statements and GST returns',
      'Order book / purchase orders where applicable',
      'Existing facility sanction letters',
      'Machinery quotations for equipment funding'
    ],
    industries: ['Manufacturing', 'Auto Components', 'Food Processing', 'Textiles', 'Chemicals', 'Engineering', 'Packaging', 'Electronics'],
    process: [
      ['MSME Assessment', 'We map your eligibility across CGTMSE, PSB and NBFC programmes.'],
      ['Documentation', 'Our team builds a complete, bank-ready proposal file.'],
      ['Multi-Lender Placement', 'Simultaneous placement with the best-fit MSME lenders.'],
      ['Sanction & Negotiation', 'We negotiate limits, margins and collateral requirements.'],
      ['Disbursement & Support', 'Ongoing support for enhancements and renewals.']
    ],
    faqs: [
      ['What funding can an MSME get without collateral?', 'Under CGTMSE, eligible MSMEs can access up to ₹5 Crore entirely collateral-free, guaranteed by the Government of India trust.'],
      ['Is Udyam registration mandatory?', 'For MSME-specific schemes, yes. Registration is free and takes minutes — our team assists you through it.'],
      ['What rates do MSMEs get?', 'PSU banks lend from 9.5% p.a. for well-rated MSMEs; NBFC programmes for thinner files range 13–18% p.a.'],
      ['Can a trading business get MSME funding?', 'Yes. Wholesale and retail traders are eligible for MSME classification and CGTMSE coverage.'],
      ['How fast is disbursement?', 'Working capital and unsecured loans: 7–15 days. CGTMSE and secured term loans: 3–5 weeks.'],
      ['My bank refused my proposal. Can you still help?', 'Frequently. A declined file usually needs restructuring and re-placement with a lender whose policy fits — that is precisely our specialisation.'],
      ['Do you help with government subsidy schemes?', 'Yes — we advise on PMEGP, CLCSS, state capital subsidies and interest subvention where your project qualifies.'],
      ['Can I fund new machinery through MSME schemes?', 'Yes. Machinery term loans with 15–25% margin, often clubbed with CGTMSE cover, fund both indigenous and imported equipment.'],
      ['What is the minimum turnover required?', 'Programmes exist from ₹40 Lakh annual turnover upward; larger limits scale with revenue and margins.'],
      ['Do you charge for eligibility assessment?', 'No. The initial consultation and eligibility mapping are entirely free.']
    ],
    related: ['cgtmse-loan', 'working-capital-finance', 'machinery-loan', 'business-loans']
  },

  'working-capital-finance': {
    name: 'Working Capital Finance',
    heroTitle: 'Working Capital That Moves at the Speed of Your Business',
    heroSub: 'Cash credit, overdrafts, bill discounting and structured working capital limits — designed around your operating cycle and placed with lenders who understand your industry.',
    amount: '₹25 Lakh – ₹100 Cr',
    timeline: '10–21 days',
    rate: '9% p.a. onwards',
    metaTitle: 'Working Capital Finance & Loans | LOANYARD CAPITAL',
    metaDescription: 'Working capital finance from ₹25 Lakh to ₹100 Cr — CC, OD, bill discounting, structured limits. Expert advisory, multiple financing partners. Free consultation.',
    focusKeyword: 'working capital loan India',
    intro: [
      'Working capital is the oxygen of any operating business. Inadequate limits force painful choices — delaying supplier payments, refusing large orders or borrowing at ruinous informal rates. Conversely, a well-structured working capital line converts your receivables, inventory and orders into reliable liquidity.',
      'LOANYARD CAPITAL designs working capital solutions around your actual operating cycle. We analyse your debtor days, inventory holding and creditor terms to compute a defensible assessment of your requirement — the same MPBF and cash-budget methods banks use — and then negotiate limits that genuinely support your growth rather than constrain it.',
      'Our mandates span the full toolkit: fund-based limits (cash credit, overdraft, WCDL), non-fund-based limits (LC, BG), receivable financing (bill and invoice discounting, factoring) and unsecured working capital for businesses without hard collateral. For growing companies, we routinely deliver 30–60% limit enhancements simply through better assessment and competitive placement.'
    ],
    benefits: [
      'Limits assessed on operating cycle, not just collateral',
      'Fund + non-fund based structures (CC, OD, WCDL, LC, BG)',
      'Interest from 9% p.a. with consortium and multiple-banking options',
      'Unsecured working capital up to ₹5 Cr for strong financials',
      'Enhancement and takeover of existing under-sized limits',
      'Industry-specialist placement across multiple financing partners'
    ],
    whoShouldApply: [
      'Manufacturers with long production-to-payment cycles',
      'Traders and distributors carrying significant inventory',
      'EPC contractors needing BG and mobilisation funding',
      'Exporters requiring pre- and post-shipment finance',
      'Businesses whose limits have not grown with turnover'
    ],
    eligibility: [
      'Business vintage of 3+ years preferred',
      'Audited financials demonstrating positive net worth',
      'Debtors predominantly within 90–120 days',
      'Satisfactory conduct of existing limits, if any',
      'Realistic projections supported by orders or trends'
    ],
    documents: [
      'Audited financials for the last 3 years',
      'Provisional financials and projections (CMA data — we prepare)',
      '12-month bank statements of all accounts',
      'Debtor–creditor ageing and stock statement',
      'GST returns and order-book summary',
      'Existing sanction letters and security details'
    ],
    industries: ['Manufacturing', 'EPC & Infrastructure', 'Pharma', 'FMCG Distribution', 'Textiles', 'Steel & Metals', 'Agro Processing', 'Electronics'],
    process: [
      ['Cycle Analysis', 'We compute your true working capital need using bank-grade methods.'],
      ['CMA & Proposal', 'Complete CMA data and credit proposal prepared by our analysts.'],
      ['Lender Placement', 'Placement with banks strong in your industry and geography.'],
      ['Limit Negotiation', 'We negotiate limits, margins, interest and collateral cover.'],
      ['Renewal Support', 'Annual renewals and enhancements managed proactively.']
    ],
    faqs: [
      ['What is the difference between CC and OD?', 'Cash credit is secured against stock and debtors with drawing power computed monthly; overdraft is typically against fixed assets or FDs with a fixed limit.'],
      ['How are working capital limits assessed?', 'Banks use MPBF (typically 75% of the working capital gap) or cash-budget methods. We prepare the assessment so your limit reflects real need.'],
      ['Can I get working capital without collateral?', 'Yes — unsecured programmes up to ₹5 Cr and CGTMSE-covered limits are available for financially sound businesses.'],
      ['My limits have not grown in years. What can be done?', 'A fresh assessment plus competitive placement usually unlocks 30–60% enhancement or a takeover by a hungrier lender at better pricing.'],
      ['What is a WCDL?', 'Working Capital Demand Loan — a fixed-tenor carve-out of your CC limit at lower interest, ideal for predictable core utilisation.'],
      ['Do you arrange non-fund-based limits?', 'Yes. LC and BG limits are structured alongside fund-based lines, often with common collateral.'],
      ['What does working capital cost?', 'Bank CC/OD runs 9–13% p.a.; NBFC and unsecured lines 14–20%. Bill discounting can be cheaper than CC for receivable-heavy businesses.'],
      ['Can seasonal businesses get flexible limits?', 'Yes — peak/non-peak limit structures align availability with your season.'],
      ['What is multiple banking vs consortium?', 'Under multiple banking each bank lends independently; a consortium shares one assessment and security pool. We advise which suits your scale.'],
      ['How long does enhancement take?', 'With complete data, enhancements typically conclude in 3–5 weeks; takeovers in 4–8 weeks.']
    ],
    related: ['bill-discounting', 'trade-finance-solutions', 'business-loans', 'msme-business-funding']
  },

  'cgtmse-loan': {
    name: 'CGTMSE Loan',
    heroTitle: 'Collateral-Free Loans up to ₹5 Crore Under CGTMSE',
    heroSub: 'Government-guaranteed funding for MSMEs — no property, no third-party guarantee. We structure and place CGTMSE proposals with the banks most active under the scheme.',
    amount: 'Up to ₹5 Cr',
    timeline: '3–5 weeks',
    rate: '9% p.a. onwards',
    metaTitle: 'CGTMSE Loan — Collateral Free up to ₹5 Cr | LOANYARD CAPITAL',
    metaDescription: 'CGTMSE collateral-free business loans up to ₹5 Crore. Government guarantee, no property needed. Expert documentation & bank placement. Check eligibility free.',
    focusKeyword: 'CGTMSE loan',
    intro: [
      'The Credit Guarantee Fund Trust for Micro and Small Enterprises (CGTMSE) is one of the most powerful — and most under-utilised — funding schemes in India. It allows banks to lend up to ₹5 Crore to eligible MSMEs without any collateral or third-party guarantee, because the Trust guarantees up to 85% of the exposure.',
      'In practice, many eligible businesses are turned away because branch officers are unfamiliar with the scheme\'s nuances or because the proposal fails internal credit filters. LOANYARD CAPITAL specialises in CGTMSE mandates: we verify eligibility, build the techno-commercial proposal, compute the guarantee coverage and place the file with banks that actively disburse under the scheme.',
      'For new units and expanding enterprises alike, CGTMSE can fund term loans for machinery and premises as well as working capital — a complete funding package with the government standing behind you instead of your family property.'
    ],
    benefits: [
      '100% collateral-free — no property or FD required',
      'Guarantee coverage up to 85% of the facility',
      'Term loan + working capital combinations permitted',
      'Available to new units and existing enterprises',
      'Interest from 9% p.a. with PSU banks',
      'Women-led and priority-category enterprises get enhanced cover'
    ],
    whoShouldApply: [
      'Micro and small enterprises without free collateral',
      'First-generation entrepreneurs setting up new units',
      'Growing MSMEs whose property is already mortgaged',
      'Women entrepreneurs (enhanced 90% guarantee cover)',
      'Service enterprises, manufacturers and eligible traders'
    ],
    eligibility: [
      'Classified as micro or small enterprise (Udyam)',
      'New or existing unit engaged in eligible activity',
      'Facility up to ₹5 Crore from a member lending institution',
      'Unit should not be a defaulter with any bank',
      'Viable project with reasonable promoter contribution'
    ],
    documents: [
      'Udyam registration and KYC documents',
      'Project report with cost and means of finance (we prepare)',
      'Financials for existing units (2 years)',
      'Bank statements and GST returns',
      'Quotations for machinery / premises',
      'Promoter net-worth statement'
    ],
    industries: ['Manufacturing', 'Food Processing', 'Healthcare Services', 'Engineering', 'Packaging', 'IT Services', 'Education Services', 'Repair & Maintenance'],
    process: [
      ['Eligibility Check', 'We confirm scheme eligibility and guarantee coverage limits.'],
      ['Project Report', 'Bank-grade project report and CMA prepared by our team.'],
      ['Bank Selection', 'Placement with branches that actively lend under CGTMSE.'],
      ['Sanction & Guarantee', 'We coordinate sanction and CGTMSE guarantee registration.'],
      ['Disbursement', 'End-to-end support until funds reach your account.']
    ],
    faqs: [
      ['Is CGTMSE really collateral-free?', 'Yes. The scheme prohibits member banks from taking collateral or third-party guarantee on covered facilities — the Trust\'s guarantee replaces it.'],
      ['What is the maximum CGTMSE loan?', '₹5 Crore per eligible borrower, covering term loans and/or working capital.'],
      ['Who pays the guarantee fee?', 'The borrower pays an annual guarantee fee (roughly 0.37%–1.35% depending on amount and category), usually added to the facility.'],
      ['Are traders eligible?', 'Yes, retail and wholesale trade are now eligible activities under the scheme.'],
      ['Can a brand-new business apply?', 'Yes. New units are explicitly covered — a strong project report substitutes for track record.'],
      ['Why do banks refuse CGTMSE files?', 'Usually weak proposals or unfamiliar branches. Correct documentation and choosing active CGTMSE branches solves most rejections.'],
      ['What coverage do women entrepreneurs get?', 'Enhanced guarantee coverage of up to 90%, making banks even more comfortable lending.'],
      ['What is the interest rate?', 'Banks price CGTMSE loans like normal MSME loans — typically 9–12% p.a. at PSU banks.'],
      ['How long does the process take?', 'With a complete file, 3–5 weeks including guarantee registration.'],
      ['Can CGTMSE fund machinery purchase?', 'Yes — term loans for machinery, equipment and even premises are standard under the scheme.']
    ],
    related: ['msme-business-funding', 'machinery-loan', 'working-capital-finance', 'business-loans']
  },

  'loan-against-property': {
    name: 'Loan Against Property',
    heroTitle: 'Unlock the Capital Locked in Your Property',
    heroSub: 'Residential, commercial or industrial — convert property into growth capital from ₹50 Lakh to ₹100 Crore at rates from 8.5% p.a., with structures including overdraft and lease-rental discounting.',
    amount: '₹50 Lakh – ₹100 Cr',
    timeline: '2–4 weeks',
    rate: '8.5% p.a. onwards',
    metaTitle: 'Loan Against Property (LAP) from 8.5% | LOANYARD CAPITAL',
    metaDescription: 'Loan against property from ₹50 Lakh to ₹100 Cr at 8.5% onwards. Residential, commercial, industrial. LAP overdraft & LRD options. Free advisory.',
    focusKeyword: 'loan against property',
    intro: [
      'For business owners, property is often the largest idle asset on the balance sheet. A well-structured Loan Against Property (LAP) converts that dormant value into the cheapest long-tenure capital available to most businesses — at nearly half the cost of unsecured debt, with tenures up to 15 years that keep EMIs comfortable.',
      'LOANYARD CAPITAL structures LAP mandates across residential, commercial and industrial properties, self-occupied or rented. Beyond the plain term loan, we advise on LAP overdraft structures (interest only on utilisation), lease-rental discounting against rented assets, and top-up strategies that maximise eligibility across property value and business cash flows.',
      'Because valuation practices, LTV caps and income assessment vary dramatically across lenders, competitive placement matters enormously in LAP. The same property and profile can produce sanction differences of 20–40% in amount and 1.5–3% in rate across institutions — differences our network is built to capture.'
    ],
    benefits: [
      'Rates from 8.5% p.a. — among the cheapest business capital',
      'Up to 75% of market value; tenures up to 15 years',
      'Residential, commercial, industrial and mixed-use accepted',
      'Overdraft variant: pay interest only on utilised amount',
      'Balance transfer + top-up on existing LAP at lower rates',
      'Funding against rented property via LRD structures'
    ],
    whoShouldApply: [
      'Business owners needing large, low-cost, long-tenure capital',
      'Companies consolidating expensive unsecured debts',
      'Promoters funding expansion without diluting equity',
      'Owners of rented commercial assets (LRD candidates)',
      'Professionals and HNIs monetising real estate holdings'
    ],
    eligibility: [
      'Clear, marketable title to the property',
      'Property in approved municipal limits',
      'Demonstrable income — business or rental — to service EMI',
      'Age 21–65 for individual borrowers',
      'Credit score of 650+ preferred'
    ],
    documents: [
      'Complete property title chain and approved plan',
      'KYC of all owners and borrowers',
      'Last 2–3 years financials / ITRs',
      '12-month bank statements',
      'Rent agreements for LRD structures',
      'Existing loan details for balance transfer'
    ],
    industries: ['All industries', 'Manufacturing', 'Healthcare', 'Hospitality', 'Education', 'Trading', 'Real Estate', 'Professional Services'],
    process: [
      ['Property & Profile Review', 'Valuation estimate and eligibility mapping across lenders.'],
      ['Structure Selection', 'Term loan, overdraft or LRD — we recommend the optimal route.'],
      ['Placement', 'Competitive placement with best-fit banks and HFCs.'],
      ['Valuation & Legal', 'We coordinate technical and legal diligence.'],
      ['Sanction & Disbursal', 'Negotiated sanction through to registered mortgage and disbursal.']
    ],
    faqs: [
      ['How much can I borrow against my property?', 'Typically 60–75% of market value, subject to income eligibility. Structured programmes assess business cash flows generously.'],
      ['Which properties qualify?', 'Residential (self-occupied or rented), commercial offices/shops, industrial units and select mixed-use properties with clear title.'],
      ['What is a LAP overdraft?', 'A limit secured by property where interest applies only on the amount utilised — ideal for businesses with fluctuating needs.'],
      ['Can I get LAP on a rented property I own?', 'Yes — and lease-rental discounting can additionally monetise the rental stream itself, often at finer rates.'],
      ['What tenure is available?', 'Up to 15 years with most lenders, keeping EMIs low relative to unsecured borrowing.'],
      ['Is LAP cheaper than a business loan?', 'Substantially. LAP runs 8.5–11% versus 14–20% for unsecured business loans.'],
      ['Can NRIs take a loan against Indian property?', 'Yes, dedicated NRI-LAP programmes exist; we manage documentation across jurisdictions.'],
      ['My property papers are complex. Can you help?', 'Our legal partners routinely resolve title-chain and approval issues before lender submission.'],
      ['Can I transfer my existing high-rate LAP?', 'Yes — balance transfer with top-up at current market rates is a routine mandate for us.'],
      ['How fast can LAP be disbursed?', 'Two to four weeks typically, driven mainly by valuation and legal clearance timelines.']
    ],
    related: ['business-loans', 'working-capital-finance', 'project-finance', 'home-loan']
  },

  'machinery-loan': {
    name: 'Machinery Loan',
    heroTitle: 'Finance the Machines That Build Your Business',
    heroSub: 'New or used, indigenous or imported — machinery and equipment finance up to ₹50 Crore with up to 90% funding, structured around your production economics.',
    amount: '₹25 Lakh – ₹50 Cr',
    timeline: '2–3 weeks',
    rate: '9.5% p.a. onwards',
    metaTitle: 'Machinery Loan & Equipment Finance | LOANYARD CAPITAL',
    metaDescription: 'Machinery loans up to ₹50 Cr — new, used & imported equipment. Up to 90% funding, 9.5% onwards, CGTMSE options. Expert placement with multiple financing partners.',
    focusKeyword: 'machinery loan',
    intro: [
      'Modern machinery is the difference between competing on price and competing on capability. Yet equipment purchases are frequently delayed because promoters hesitate to deploy working capital into fixed assets — precisely the problem machinery finance solves, by matching long-life assets with long-tenure debt.',
      'LOANYARD CAPITAL arranges machinery and equipment finance across the spectrum: CNC and printing machines, textile and packaging lines, construction equipment, medical devices and imported speciality machinery. Funding extends up to 90% of the invoice value (including, in many programmes, installation, taxes and accessories), with tenures of up to 7 years aligned to the asset\'s productive life.',
      'For imported machines, we structure buyer\'s credit, foreign currency term loans and LC-backed purchases that reduce effective interest cost. For eligible MSMEs, CGTMSE cover can make the entire facility collateral-free — the machine itself is the primary security.'
    ],
    benefits: [
      'Up to 90% of invoice value funded, including soft costs',
      'New, refurbished and imported machinery covered',
      'Collateral-light: the machine is the primary security',
      'CGTMSE option makes MSME facilities collateral-free',
      'Buyer\'s credit / FC loans reduce cost for imports',
      'Tenures up to 7 years matched to asset life'
    ],
    whoShouldApply: [
      'Manufacturers adding or modernising capacity',
      'Printing, packaging and textile units upgrading lines',
      'Contractors acquiring construction equipment',
      'Hospitals and diagnostics buying medical equipment',
      'Exporters importing speciality machinery'
    ],
    eligibility: [
      'Business vintage of 2–3 years',
      'Financials supporting the incremental EMI',
      'Firm quotation / proforma invoice for the machine',
      'Satisfactory banking and bureau conduct',
      'Margin contribution of 10–25%'
    ],
    documents: [
      'Machine quotation / proforma invoice',
      'Business KYC and Udyam certificate',
      'Last 2 years financials and ITRs',
      '12-month bank statements',
      'GST returns',
      'Import documents (for imported machinery)'
    ],
    industries: ['Engineering', 'Textiles', 'Printing & Packaging', 'Pharma & Medical', 'Plastics', 'Food Processing', 'Construction', 'Auto Components'],
    process: [
      ['Requirement & Quote', 'We review the machine, vendor and commercial terms.'],
      ['Structure', 'Term loan, CGTMSE, leasing or FC route — optimally selected.'],
      ['Placement', 'Placement with lenders strong in your equipment category.'],
      ['Sanction', 'Negotiation of margin, rate and tenure.'],
      ['Disbursal to Vendor', 'Direct disbursal to supplier; import coordination if needed.']
    ],
    faqs: [
      ['How much of the machine cost is funded?', 'Typically 75–90% of invoice value; strong profiles can include GST, transport and installation in funding.'],
      ['Can used machinery be financed?', 'Yes — refurbished and second-hand machines up to a certain age qualify, subject to valuation.'],
      ['Is collateral needed beyond the machine?', 'Often no. The equipment hypothecation suffices; CGTMSE can eliminate collateral for MSMEs entirely.'],
      ['Can imported machinery be funded?', 'Yes — via LC, buyer\'s credit or foreign-currency term loans, often at lower effective rates.'],
      ['What tenure applies?', 'Three to seven years depending on machine life and cash flows.'],
      ['What rates should I expect?', 'Banks: 9.5–12% p.a.; NBFC equipment programmes: 12–16% with faster turnaround.'],
      ['How fast can a machinery loan close?', 'NBFC routes close in 7–10 days; bank term loans in 2–3 weeks.'],
      ['Does the loan cover installation and accessories?', 'Many programmes include erection, electricals and essential accessories within the funded cost.'],
      ['Can I finance multiple machines together?', 'Yes — a consolidated capex line covering the full expansion is usually more efficient.'],
      ['Is machinery refinance possible?', 'Yes — unencumbered machines can be refinanced to release liquidity into the business.']
    ],
    related: ['medical-equipment-finance', 'msme-business-funding', 'cgtmse-loan', 'project-finance']
  },

  'medical-equipment-finance': {
    name: 'Medical Equipment Finance',
    heroTitle: 'Advanced Medical Technology, Financed Intelligently',
    heroSub: 'MRI, CT, cath labs, modular OTs and complete hospital projects — equipment finance built for doctors, diagnostics chains and hospitals, up to ₹50 Crore.',
    amount: '₹25 Lakh – ₹50 Cr',
    timeline: '1–3 weeks',
    rate: '9% p.a. onwards',
    metaTitle: 'Medical Equipment Finance for Doctors & Hospitals | LOANYARD CAPITAL',
    metaDescription: 'Medical equipment loans up to ₹50 Cr — MRI, CT, cath lab, OT. Up to 100% funding for doctors & hospitals at 9% onwards. Fast sanction. Free advisory.',
    focusKeyword: 'medical equipment finance',
    intro: [
      'Healthcare is a technology business. The difference between a good practice and a great institution is often a ₹5–15 crore equipment decision — an MRI that brings diagnostics in-house, a cath lab that transforms cardiac care, a modular OT that attracts leading surgeons. Medical equipment finance exists so that clinical ambition is never hostage to capital.',
      'LOANYARD CAPITAL runs a dedicated healthcare desk. We finance individual practitioners, diagnostic centres, nursing homes and multi-speciality hospitals — from a single ultrasound machine to complete greenfield hospital equipment packages. Doctor-special programmes offer up to 100% funding with minimal financials, recognising the profession\'s exceptional credit quality.',
      'For high-value imported systems, we structure vendor-partnered deals, buyer\'s credit and leasing alternatives that protect cash flow and optimise tax treatment — and we negotiate directly with OEM financing arms where their subsidised rates beat the market.'
    ],
    benefits: [
      'Up to 100% funding for qualified medical professionals',
      'Covers MRI, CT, cath lab, dialysis, OT, dental & diagnostics',
      'Doctor programmes with minimal income documentation',
      'Leasing and buyer\'s credit for imported systems',
      'Tenures up to 7 years; step-up EMIs for new centres',
      'OEM tie-up rates negotiated where advantageous'
    ],
    whoShouldApply: [
      'Individual doctors and specialist practitioners',
      'Diagnostic and imaging centre operators',
      'Nursing homes and single-speciality clinics',
      'Multi-speciality and greenfield hospitals',
      'Dental, ophthalmic and IVF chains'
    ],
    eligibility: [
      'Medical registration (for practitioner programmes)',
      '2+ years of practice preferred (relaxed for specialists)',
      'Equipment quotation from recognised OEM/dealer',
      'Basic income documents; enhanced for large tickets',
      'Hospital projects: DPR and promoter contribution'
    ],
    documents: [
      'Medical degree & council registration',
      'Equipment proforma invoice',
      'KYC and practice/entity documents',
      'ITRs / financials (programme-dependent)',
      'Bank statements (6–12 months)',
      'Project report for hospital-scale funding'
    ],
    industries: ['Hospitals', 'Diagnostics & Imaging', 'Pathology Labs', 'Dental Chains', 'Ophthalmology', 'IVF & Fertility', 'Dialysis Centres', 'Veterinary'],
    process: [
      ['Clinical & Financial Review', 'Equipment economics and repayment capacity assessed.'],
      ['Programme Selection', 'Doctor-special, hospital term loan, lease or OEM route.'],
      ['Placement', 'Placement with healthcare-focused lenders and OEM arms.'],
      ['Sanction', 'Fast-track approvals; step-up structures where useful.'],
      ['Vendor Disbursal', 'Direct payment to OEM; import handling included.']
    ],
    faqs: [
      ['Can doctors really get 100% equipment funding?', 'Yes. Practising doctors with clean credit routinely receive 90–100% funding on equipment under professional programmes.'],
      ['What equipment can be financed?', 'Everything from ultrasound and dental chairs to MRI, CT, PET-CT, cath labs, linear accelerators and modular OT setups.'],
      ['What rates apply for medical equipment?', 'Doctor programmes start around 9–11% p.a.; hospital-scale term loans are priced on project strength.'],
      ['How quickly can a sanction happen?', 'Practitioner tickets often sanction within 5–10 days; large hospital packages in 3–4 weeks.'],
      ['Is leasing better than a loan?', 'Leasing preserves capital and may offer tax efficiency; we model both and recommend based on your P&L.'],
      ['Can a new clinic get equipment finance?', 'Yes — specialist qualifications and a sound location plan can substitute for vintage under several programmes.'],
      ['Do you fund imported medical systems?', 'Yes, including LC establishment, buyer\'s credit and customs-duty funding.'],
      ['Can equipment finance be part of a hospital project loan?', 'Absolutely — we structure integrated project debt covering civil, equipment and working capital.'],
      ['Is collateral required?', 'Usually only equipment hypothecation for standard tickets; large exposures may need project security.'],
      ['Do you work with OEM financing arms?', 'Yes — where OEM captive finance offers subsidised rates, we negotiate and compare against bank options for you.']
    ],
    related: ['machinery-loan', 'project-finance', 'business-loans', 'loan-against-property']
  }
};
